export default __webpack_public_path__ + "images/9L.c01c98d.png";